import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import OfflineEventInformation from './OfflineEventInformation';
import VirtualEventInformation from './VirtualEventInformation';
import { readJson } from '../../utils/generateToken';

const EventInformation = () => {
  // console.log('Event Information');
  //#region variable, state, initial value

  const [ev, setEv] = useState();
  const { item } = useParams();

  useEffect(() => {
    const fromRead = JSON.parse(readJson(item));
    // console.log('fromRead ', fromRead);
    setEv(fromRead);
  }, []);

  // console.log('item from params ', readJson(item));

  if (ev?.type === 'OFFLINE') return <OfflineEventInformation id={ev?.id} />;
  if (ev?.type === 'VIRTUAL') return <VirtualEventInformation id={ev?.id} />;
};

export default EventInformation;
